import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';

import { useUser } from '@/hooks/use-user';

import { useCurrentFacility } from './use-current-facility';

/**
 * Use LaunchDarkly Context
 * Sets the LaunchDarkly context for the current user, organization, facility, and agent
 */
export const useLaunchDarklyContext = () => {
  const { userId, email, name } = useUser();
  const { organizationId, facilityId, agentId } = useCurrentFacility();
  const ldClient = useLDClient();

  // Set LaunchDarkly context
  useEffect(() => {
    console.debug('[LaunchDarkly] Setting context - Client exists?', !!ldClient);
    console.debug('[LaunchDarkly] User info:', { userId, email, name });
    console.debug('[LaunchDarkly] Facility info:', { organizationId, facilityId, agentId });

    if (!ldClient) {
      console.debug('[LaunchDarkly] No client available, skipping context setup');
      return;
    }
    const ldContext: any = { kind: 'multi' };
    let setContext = false;
    if (userId) {
      ldContext.user = {
        key: email,
        email: email,
        userId: userId,
        name: name,
      };
      setContext = true;
    }
    if (organizationId) {
      ldContext.organization = { key: organizationId };
      setContext = true;
    }
    if (facilityId) {
      ldContext.facility = { key: facilityId };
      setContext = true;
    }
    if (agentId) {
      ldContext.agent = { key: agentId };
      setContext = true;
    }
    console.debug('[LaunchDarkly] Context to set:', ldContext);
    if (setContext) {
      console.debug('[LaunchDarkly] Calling identify with context');
      ldClient?.identify(ldContext).catch((error) => {
        console.error('[LaunchDarkly] Failed to identify context:', error);
        // Continue operation - feature flags will use defaults or anonymous context
      });
    } else {
      console.debug('[LaunchDarkly] No context to set');
    }
  }, [userId, email, name, organizationId, facilityId, agentId, ldClient]);
};
